import { createContext, useContext, useReducer } from 'react';
import React from 'react';

const GroupDetailsContext = createContext();

const initialState = {
    data: null,
    // other initial state properties...
};

const groupDetailsReducer = (state, action) => {
    switch (action.type) {
        case 'SET_DATA':
            return { ...state, data: action.payload };
        // handle other actions as needed...
        default:
            return state;
    }
};

export const GroupDetailsProvider = ({ children }) => {
    const [state, dispatch] = useReducer(groupDetailsReducer, initialState);

    return (
        <GroupDetailsContext.Provider value={{ state, dispatch }}>
            {children}
        </GroupDetailsContext.Provider>
    );
};


export const useGroupDetailsContext = () => {
    return useContext(GroupDetailsContext);
};
